module.exports = __webpack_public_path__ + "img/garage-repair-unlimited.7d03ff54.jpg";